import { z } from "zod";

/**
 * Shared Zod schema for returning customer pricing configuration.
 * Import this into every payment provider's appDataSchema so the field
 * survives eventTypeMetaDataSchemaWithTypedApps.parse() and reaches
 * getPaymentAppData without being stripped as an unknown key.
 */
export const returningCustomerPricingSchema = z.object({
  enabled: z.boolean(),
  /** Price for first-time customers, in smallest currency unit (e.g. cents) */
  newCustomerPrice: z.number().min(0),
  /** Price for returning customers after minimumPriorBookings, in smallest currency unit */
  returningCustomerPrice: z.number().min(0),
  /** "event" = prior bookings of this event type only; "organizer" = any booking with this organizer */
  scope: z.enum(["event", "organizer"]),
  /** Minimum prior accepted/pending bookings to be considered "returning" (tier 2) */
  minimumPriorBookings: z.number().int().min(1),
  /** Optional third tier: price after tier2MinBookings prior bookings, in smallest currency unit */
  tier2Price: z.number().min(0).optional(),
  /** How many prior bookings required to reach the third tier */
  tier2MinBookings: z.number().int().min(2).optional(),
});

export type ReturningCustomerPricingConfig = z.infer<typeof returningCustomerPricingSchema>;
